import { Nullable } from '@clearverify/types';

import { useSearch } from 'src/hooks/common/useSearch';

import { useDemoPrivacyMode } from './useDemoPrivacyMode';

const hasActiveSearch = (searchValue: Nullable<string>) => {
  return Boolean(searchValue && searchValue.length > 0);
};

export const useDemoPrivacyBlurred = (forceReveal?: boolean) => {
  const { isDemoPrivacyModeEnabled } = useDemoPrivacyMode();
  const { searchValue } = useSearch();

  const isRevealed = forceReveal ?? hasActiveSearch(searchValue);

  return isDemoPrivacyModeEnabled && !isRevealed;
};
